<div class="file-icon" [ngClass]="{ 'big': bigIcon }">
  <mat-icon [svgIcon]="iconName"></mat-icon>
</div>
<div class="pt-5 mt-2">
  <h1 class="line1 mb-0">{{ line1 | translate }}<span *ngIf="line2">,</span></h1>
  <h1 class="line2" *ngIf="line2">{{ line2 | translate }}</h1>
</div>